// Display metadata from an accepted load or immutable receipt only. Callers
// choose that authority; this helper never reads requested user settings.
export function loadedFactorSlice(context) {
    if (!context || typeof context !== 'object' || Array.isArray(context)) return null;
    const text = (value) => typeof value === 'string' ? value.trim() : '';
    const vendor = text(context.vendor || context.provider_vendor || context.factorModel
        || (context.factor_data_model ? context.factor_model : null));
    const baseModel = text(context.model || context.factorDataModel || context.factor_data_model
        || context.factor_model);
    const horizon = text(context.horizon || context.factor_horizon);
    const date = text(context.date || context.factorSnapshotDate || context.factor_snapshot_date
        || context.factor_as_of_date);
    if (!vendor || !baseModel || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;
    const model = horizon && !baseModel.endsWith(`-${horizon}`) ? `${baseModel}-${horizon}` : baseModel;
    return { vendor, model, date };
}

export function loadedFactorSliceLabel(context, resultLoaded = false) {
    const slice = loadedFactorSlice(context);
    if (!slice) return resultLoaded ? 'Factor slice unavailable' : 'Factor data not loaded';
    const vendor = slice.vendor.charAt(0).toUpperCase() + slice.vendor.slice(1).toLowerCase();
    return `${vendor} · ${slice.model} · ${slice.date}`;
}

export function loadedWorkspaceFactorState(workspace, userUid, scopeKey) {
    const accepted = Boolean(userUid && scopeKey && workspace?.factorSliceAccepted
        && workspace.factorSliceUserUid === userUid
        && workspace.factorSliceScopeKey === scopeKey);
    return { context: accepted ? workspace.factorSlice : null, resultLoaded: accepted };
}

export function invalidateLoadedWorkspaceFactorSlice(workspace) {
    return workspace ? { ...workspace, factorSliceAccepted: false, factorSlice: null } : workspace;
}
